// TODO 項目が全部ベタ書き
<template lang="pug">
  section
    v-tabs(color="primary darken-2" dark slider-color="yellow darken-2" v-model="model")
      v-tab(href="#tab1")
        div 状態
      v-tab(href="#tab2")
        div 荷主
      v-tab(href="#tab3")
        div 車庫エリア
    v-tabs-items(v-model="model")
      v-tab-item(value="tab1")
        v-card(flat)
          v-card-text.filter-container(v-if="!isDynamic")
            v-layout(row wrap)
              // 左カラム - 乗務員条件
              v-flex(xs12 md4)
                v-card.filter-card(outlined)
                  v-card-title.py-2
                    span.subheading 乗務員条件
                  v-divider
                  v-card-text.pa-2
                    v-layout(row wrap)
                      v-flex(xs12)
                        .item-label 運転可能車格
                        .item-content
                          template(v-for="vehicleType in searchCondItem.drivableVehicleType")
                            BaseFilterChip(:chipName="vehicleType.label" :active="vehicleType.active" @changeFilter="(value) => vehicleType.active = value")

                      v-flex(xs12)
                        .item-label 運転可能リフト
                        .item-content
                          BaseFilterChip(chipName="リーチ" :active="searchCondItem.liftType.reach.active" @changeFilter="(value) => searchCondItem.liftType.reach.active = value")
                          BaseFilterChip(chipName="カウンター" :active="searchCondItem.liftType.counter.active" @changeFilter="(value) => searchCondItem.liftType.counter.active = value")
                          BaseFilterChip(chipName="両方" :active="searchCondItem.liftType.both.active" @changeFilter="(value) => searchCondItem.liftType.both.active = value")

                      v-flex(xs12)
                        .item-label 契約条件
                        .item-content
                          BaseFilterChip(chipName="直接雇用" :active="searchCondItem.contractType.employee.active" @changeFilter="(value) => searchCondItem.contractType.employee.active = value")
                          BaseFilterChip(chipName="専属" :active="searchCondItem.contractType.exclusive.active" @changeFilter="(value) => searchCondItem.contractType.exclusive.active = value")
                          BaseFilterChip(chipName="スポット" :active="searchCondItem.contractType.spot.active" @changeFilter="(value) => searchCondItem.contractType.spot.active = value")

                      v-flex(xs12)
                        .item-label 勤務シフト
                        .item-content
                          BaseFilterChip(chipName="日勤" :active="searchCondItem.driverShift.day.active" @changeFilter="(value) => searchCondItem.driverShift.day.active = value")
                          BaseFilterChip(chipName="夜勤" :active="searchCondItem.driverShift.night.active" @changeFilter="(value) => searchCondItem.driverShift.night.active = value")
                          BaseFilterChip(chipName="非番" :active="searchCondItem.driverShift.rest.active" @changeFilter="(value) => searchCondItem.driverShift.rest.active = value")

                      v-flex(xs12)
                        .item-label 乗務員連絡
                        .item-content
                          BaseFilterChip(chipName="LINE可" :active="searchCondItem.driverContactType.line.active" @changeFilter="setDriverContactTypeLine")
                          BaseFilterChip(chipName="メール可" :active="searchCondItem.driverContactType.mail.active" @changeFilter="setDriverContactTypeMail")
                          BaseFilterChip(chipName="不可" :active="searchCondItem.driverContactType.none.active" @changeFilter="setDriverContactTypeNone")

                      v-flex(xs12)
                        .item-label 乗務員
                          v-text-field(v-model="searchCondItem.driverName" dense hide-details)

                      v-flex(xs6 pr-1)
                        .item-label 1次委託先
                        v-text-field(v-model="searchCondItem.primaryContractorName" dense hide-details)

                      v-flex(xs6 pl-1)
                        .item-label 所属会社
                        v-text-field(v-model="searchCondItem.deliveryCompanyName" dense hide-details)

              // 中央カラム - 車両条件
              v-flex(xs12 md4)
                v-card.filter-card(outlined)
                  v-card-title.py-2
                    span.subheading 車両条件
                  v-divider
                  v-card-text.pa-2
                    v-layout(row wrap)
                      v-flex(xs12)
                        .item-label 車両車格
                        .item-content
                          template(v-for="vehicleType in searchCondItem.vehicleType")
                            BaseFilterChip(:chipName="vehicleType.label" :active="vehicleType.active" @changeFilter="(value) => vehicleType.active = value")

                      v-flex(xs12)
                        .item-label 車両積載重量
                        .item-content
                          BaseFilterChip(chipName="～11t" :active="searchCondItem.vehicleCarryWeight.w0_11.active" @changeFilter="(value) => searchCondItem.vehicleCarryWeight.w0_11.active = value")
                          BaseFilterChip(chipName="11～13t" :active="searchCondItem.vehicleCarryWeight.w11_13.active" @changeFilter="(value) => searchCondItem.vehicleCarryWeight.w11_13.active = value")
                          BaseFilterChip(chipName="13～14t" :active="searchCondItem.vehicleCarryWeight.w13_14.active" @changeFilter="(value) => searchCondItem.vehicleCarryWeight.w13_14.active = value")
                          BaseFilterChip(chipName="14t～" :active="searchCondItem.vehicleCarryWeight.w14_o.active" @changeFilter="(value) => searchCondItem.vehicleCarryWeight.w14_o.active = value")

                      v-flex(xs12)
                        .item-label 拠点要求オプション
                        .item-content
                          template(v-for="option in searchCondItem.vehicleOption")
                            BaseFilterChip(:chipName="option.label" :active="option.active" @changeFilter="(value) => option.active = value")

                      v-flex(xs12)
                        .item-label 車番
                        v-text-field(v-model="searchCondItem.vehicleNumber" maxlength="50" dense hide-details)
                // 警告条件
                v-card.mt-2.filter-card(outlined)
                  v-card-title.py-2
                    span.subheading 警告カード条件
                  v-divider
                  v-card-text.pa-2
                    v-layout(row wrap)
                      v-flex(shrink mr-3)
                        .filter-item-compact
                          .item-label 車両利用不可
                          .item-content
                            BaseFilterChip(chipName="適用" :active="searchCondItem.isVehicleInActive" @changeFilter="(value) => searchCondItem.isVehicleInActive = value")

                      v-flex(shrink mr-3)
                        .filter-item-compact
                          .item-label リフトタイプ不足
                          .item-content
                            BaseFilterChip(chipName="適用" :active="searchCondItem.isIncompleteLiftType" @changeFilter="(value) => searchCondItem.isIncompleteLiftType = value")

                      v-flex(shrink mr-3)
                        .filter-item-compact
                          .item-label 車両オプション不足
                          .item-content
                            BaseFilterChip(chipName="適用" :active="searchCondItem.isIncompleteVehicleOption" @changeFilter="(value) => searchCondItem.isIncompleteVehicleOption = value")

                      v-flex(shrink mr-3)
                        .filter-item-compact
                          .item-label BJI48/24 積卸数変更有
                          .item-content
                            BaseFilterChip(chipName="適用" :active="searchCondItem.isBjiImportBaseChanged" @changeFilter="(value) => searchCondItem.isBjiImportBaseChanged = value")

                      v-flex(shrink mr-3)
                        .filter-item-compact
                          .item-label 重量オーバー
                          .item-content
                            BaseFilterChip(chipName="適用" :active="searchCondItem.isOverWeight" @changeFilter="(value) => searchCondItem.isOverWeight = value")
                            BaseFilterChip(chipName="BJI差分" :active="searchCondItem.isOverWeightBjiDiff" @changeFilter="(value) => searchCondItem.isOverWeightBjiDiff = value")

              // 右カラム - カード・配送条件
              v-flex(xs12 md4)
                v-card.filter-card(outlined)
                  v-card-title.py-2
                    span.subheading カード・配送条件
                  v-divider
                  v-card-text.pa-2
                    v-layout(row wrap)
                      v-flex(xs12)
                        .item-label マーク
                        .item-content.mark-chips
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark1.active" @changeFilter="(value) => searchCondItem.mark.mark1.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark1" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark2.active" @changeFilter="(value) => searchCondItem.mark.mark2.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark2" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark3.active" @changeFilter="(value) => searchCondItem.mark.mark3.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark3" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark4.active" @changeFilter="(value) => searchCondItem.mark.mark4.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark4" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark5.active" @changeFilter="(value) => searchCondItem.mark.mark5.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark5" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark6.active" @changeFilter="(value) => searchCondItem.mark.mark6.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark6" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark7.active" @changeFilter="(value) => searchCondItem.mark.mark7.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark7" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark8.active" @changeFilter="(value) => searchCondItem.mark.mark8.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark8" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark9.active" @changeFilter="(value) => searchCondItem.mark.mark9.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark9" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark10.active" @changeFilter="(value) => searchCondItem.mark.mark10.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark10" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark11.active" @changeFilter="(value) => searchCondItem.mark.mark11.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark11" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark12.active" @changeFilter="(value) => searchCondItem.mark.mark12.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark12" :color="currentColor")
                          BaseFilterChip(chipName="" :active="searchCondItem.mark.mark13.active" @changeFilter="(value) => searchCondItem.mark.mark13.active = value")
                            template(v-slot:icon="{ currentColor }")
                              ClassifiedCardMarkIcon(:markType="Mark13" :color="currentColor")

                      v-flex(xs12)
                        .item-label シップ/受付/中継番号
                        v-textarea(v-model="searchCondItem.shipmentNo" maxlength=700 rows="1" dense hide-details)

                      v-flex(xs6 pr-1)
                        .item-label 積地名
                        v-text-field(v-model="searchCondItem.loadingBaseName" dense hide-details)

                      v-flex(xs6 pl-1)
                        .item-label 卸地名
                        v-text-field(v-model="searchCondItem.unloadingBaseName" dense hide-details)

                      v-flex(xs6)
                        .item-label 運行状態
                        .item-content
                          BaseFilterChip(chipName="第1運行未設定" :active="searchCondItem.operatingConditions.isNotFirst.active" @changeFilter="(value) => searchCondItem.operatingConditions.isNotFirst.active = value")
                          BaseFilterChip(chipName="宵積み" :active="searchCondItem.operatingConditions.isNightLoading.active" @changeFilter="(value) => searchCondItem.operatingConditions.isNightLoading.active = value")

                      v-flex(xs6)
                        .item-label 積載条件
                        .item-content
                          BaseFilterChip(chipName="時間指定" :active="searchCondItem.specifiedTime" @changeFilter="(value) => searchCondItem.specifiedTime = value")

                      v-flex(shrink mr-3)
                        .item-label お気に入り
                        .item-content
                          BaseFilterChip(chipName="適用" :active="searchCondItem.isFavoriteOn" @changeFilter="(value) => searchCondItem.isFavoriteOn = value")

                      v-flex(shrink mr-3)
                          .item-label お気に入りなし
                          .item-content
                            BaseFilterChip(chipName="適用" :active="searchCondItem.isFavoriteOff" @changeFilter="(value) => searchCondItem.isFavoriteOff = value")

                      v-flex(shrink mr-3)
                        .item-label 空車回送
                        .item-content
                          BaseFilterChip(chipName="適用" :active="searchCondItem.isEmptyCard" @changeFilter="(value) => searchCondItem.isEmptyCard = value")

                      v-flex(shrink)
                        .item-label スライド(先)
                        .item-content
                          BaseFilterChip(chipName="適用" :active="searchCondItem.isSlideDestCard" @changeFilter="(value) => searchCondItem.isSlideDestCard = value")

                      v-flex(xs6 pr-1)
                        .item-label 配車明細ID
                        v-text-field(v-model="searchCondItem.dispatchDetailIds" maxlength="30" dense hide-details)

                      v-flex(xs6 pl-1)
                        .item-label カードID
                        v-text-field(v-model="searchCondItem.cardIds" maxlength="30" dense hide-details)

            // メール・LINE配信状態 (全幅 - コンパクト版)
            v-layout(row wrap).mt-2
              v-flex(xs12)
                v-card.filter-card(outlined)
                  v-card-title.py-2
                    span.subheading メール・LINE配信状態
                  v-divider
                  v-card-text.pa-2
                    v-layout(row wrap)
                      v-flex(xs12 md3)
                        .filter-item-compact
                          .item-label メール(第1運行)
                          .item-content
                            BaseFilterChip(chipName="未配信" :active="searchCondItem.firstMailType.unsent.active" @changeFilter="(value) => searchCondItem.firstMailType.unsent.active = value")
                            BaseFilterChip(chipName="配信済" :active="searchCondItem.firstMailType.sent.active" @changeFilter="(value) => searchCondItem.firstMailType.sent.active = value")
                            BaseFilterChip(chipName="開封済" :active="searchCondItem.firstMailType.read.active" @changeFilter="(value) => searchCondItem.firstMailType.read.active = value")
                            BaseFilterChip(chipName="承認済" :active="searchCondItem.firstMailType.confirmed.active" @changeFilter="(value) => searchCondItem.firstMailType.confirmed.active = value")

                      v-flex(xs12 md3)
                        .filter-item-compact
                          .item-label LINE(第1運行)
                          .item-content
                            BaseFilterChip(chipName="未配信" :active="searchCondItem.firstLineType.unsent.active" @changeFilter="(value) => searchCondItem.firstLineType.unsent.active = value")
                            BaseFilterChip(chipName="配信済" :active="searchCondItem.firstLineType.sent.active" @changeFilter="(value) => searchCondItem.firstLineType.sent.active = value")
                            BaseFilterChip(chipName="開封済" :active="searchCondItem.firstLineType.read.active" @changeFilter="(value) => searchCondItem.firstLineType.read.active = value")
                            BaseFilterChip(chipName="承認済" :active="searchCondItem.firstLineType.confirmed.active" @changeFilter="(value) => searchCondItem.firstLineType.confirmed.active = value")

                      v-flex(xs12 md3)
                        .filter-item-compact
                          .item-label メール(全運行)
                          .item-content
                            BaseFilterChip(chipName="未配信" :active="searchCondItem.allMailType.unsent.active" @changeFilter="(value) => searchCondItem.allMailType.unsent.active = value")
                            BaseFilterChip(chipName="配信済" :active="searchCondItem.allMailType.sent.active" @changeFilter="(value) => searchCondItem.allMailType.sent.active = value")
                            BaseFilterChip(chipName="開封済" :active="searchCondItem.allMailType.read.active" @changeFilter="(value) => searchCondItem.allMailType.read.active = value")
                            BaseFilterChip(chipName="承認済" :active="searchCondItem.allMailType.confirmed.active" @changeFilter="(value) => searchCondItem.allMailType.confirmed.active = value")

                      v-flex(xs12 md3)
                        .filter-item-compact
                          .item-label LINE(全運行)
                          .item-content
                            BaseFilterChip(chipName="未配信" :active="searchCondItem.allLineType.unsent.active" @changeFilter="(value) => searchCondItem.allLineType.unsent.active = value")
                            BaseFilterChip(chipName="配信済" :active="searchCondItem.allLineType.sent.active" @changeFilter="(value) => searchCondItem.allLineType.sent.active = value")
                            BaseFilterChip(chipName="開封済" :active="searchCondItem.allLineType.read.active" @changeFilter="(value) => searchCondItem.allLineType.read.active = value")
                            BaseFilterChip(chipName="承認済" :active="searchCondItem.allLineType.confirmed.active" @changeFilter="(value) => searchCondItem.allLineType.confirmed.active = value")


          v-card-text(v-if="isDynamic")
            v-layout(row wrap align-center justify-start fill-height)
              v-flex.subheading(xs6)
                span 乗務員条件
              v-flex.subheading(xs6)
                span カード条件
            // line
            v-layout(row wrap align-center justify-start fill-height)
              v-flex.item-name(xs2)
                span 運転可能車格
              v-flex(xs4)
                template(v-for="vehicleType in searchCondItem.drivableVehicleType")
                  BaseFilterChip(:chipName="vehicleType.label" :active="vehicleType.active" @changeFilter="(value) => vehicleType.active = value")

              v-flex.item-name(xs2)
                span 車両車格
              v-flex(xs4)
                template(v-for="vehicleType in searchCondItem.vehicleType")
                  BaseFilterChip(:chipName="vehicleType.label" :active="vehicleType.active" @changeFilter="(value) => vehicleType.active = value")

            // line
            v-layout(row wrap align-center justify-start fill-height)
              v-flex.item-name(xs2)
                span 1次委託先会社
              v-flex(xs3)
                v-text-field(v-model="searchCondItem.primaryContractorName")

              v-flex(xs1)
              v-flex.item-name(xs2)
                span マーク
              v-flex(xs4)
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark1.active" @changeFilter="(value) => searchCondItem.mark.mark1.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark1" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark2.active" @changeFilter="(value) => searchCondItem.mark.mark2.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark2" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark3.active" @changeFilter="(value) => searchCondItem.mark.mark3.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark3" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark4.active" @changeFilter="(value) => searchCondItem.mark.mark4.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark4" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark5.active" @changeFilter="(value) => searchCondItem.mark.mark5.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark5" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark6.active" @changeFilter="(value) => searchCondItem.mark.mark6.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark6" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark7.active" @changeFilter="(value) => searchCondItem.mark.mark7.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark7" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark8.active" @changeFilter="(value) => searchCondItem.mark.mark8.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark8" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark9.active" @changeFilter="(value) => searchCondItem.mark.mark9.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark9" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark10.active" @changeFilter="(value) => searchCondItem.mark.mark10.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark10" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark11.active" @changeFilter="(value) => searchCondItem.mark.mark11.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark11" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark12.active" @changeFilter="(value) => searchCondItem.mark.mark12.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark12" :color="currentColor")
                BaseFilterChip(chipName="" :active="searchCondItem.mark.mark13.active" @changeFilter="(value) => searchCondItem.mark.mark13.active = value")
                  template(v-slot:icon="{ currentColor }")
                    ClassifiedCardMarkIcon(:markType="Mark13" :color="currentColor")


            // line
            v-layout(row wrap align-center justify-start fill-height)
              v-flex.item-name(xs2)
                span 所属会社
              v-flex(xs3)
                v-text-field(v-model="searchCondItem.deliveryCompanyName")
              v-flex(xs1)
              v-flex.item-name(xs2)
                span 車番
              v-flex(xs3)
                v-text-field(v-model="searchCondItem.vehicleNumber" maxlength="50")

            // line
            v-layout(row wrap align-center justify-start fill-height)
              v-flex.item-name(xs2)
                span 乗務員名
              v-flex(xs3)
                v-text-field(v-model="searchCondItem.driverName")
              v-flex(xs1)
              v-flex.item-name(xs2)
                span シップ/受付/中継番号
              v-flex(xs3)
                v-textarea(v-model="searchCondItem.shipmentNo" maxlength=700 rows="1")

            // line
            v-layout(row wrap align-center justify-start fill-height)
              v-flex.item-name(xs2)
                span 積地名
              v-flex(xs3)
                v-text-field(v-model="searchCondItem.loadingBaseName")
              v-flex(xs1)
              v-flex.item-name(xs2)
                span 卸地名
              v-flex(xs3)
                v-text-field(v-model="searchCondItem.unloadingBaseName")

            // line
            v-layout(row wrap align-center justify-start fill-height)
              v-flex.item-name(xs2)
                span 契約条件
              v-flex(xs4)
                BaseFilterChip(chipName="直接雇用" :active="searchCondItem.contractType.employee.active" @changeFilter="(value) => searchCondItem.contractType.employee.active = value")
                BaseFilterChip(chipName="専属" :active="searchCondItem.contractType.exclusive.active" @changeFilter="(value) => searchCondItem.contractType.exclusive.active = value")
                BaseFilterChip(chipName="スポット" :active="searchCondItem.contractType.spot.active" @changeFilter="(value) => searchCondItem.contractType.spot.active = value")
              v-flex.item-name(xs2)
                span 配車明細ID
              v-flex(xs3)
                v-text-field(v-model="searchCondItem.dispatchDetailIds" maxlength="30")

            // line
            v-layout(row wrap align-center justify-start fill-height)
              v-flex.item-name(xs2)
                span 配送状態
              v-flex(xs4)
                BaseFilterChip(chipName="未配送" :active="searchCondItem.isComplete === '0'" @changeFilter="(value) =>  searchCondItem.isComplete === (value ? '0' : '1') ? searchCondItem.isComplete = null : searchCondItem.isComplete = '0'")
                BaseFilterChip(chipName="配送完了" :active="searchCondItem.isComplete === '1'" @changeFilter="(value) => searchCondItem.isComplete === (value ? '1' : '0') ? searchCondItem.isComplete = null : searchCondItem.isComplete = '1'")
              v-flex.item-name(xs2)
                span ナビッピ対象のみ
              v-flex(xs4)
                BaseFilterChip(chipName="適用" :active="searchCondItem.onlyGps === true" @changeFilter="(value) => searchCondItem.onlyGps = value")

            // line
            v-layout(row wrap align-center justify-start fill-height)
              v-flex.item-name(xs2)
                span 勤務シフト
              v-flex(xs4)
                BaseFilterChip(chipName="日勤" :active="searchCondItem.driverShift.day.active" @changeFilter="(value) => searchCondItem.driverShift.day.active = value")
                BaseFilterChip(chipName="夜勤" :active="searchCondItem.driverShift.night.active" @changeFilter="(value) => searchCondItem.driverShift.night.active = value")

              v-flex.item-name(xs2)
                span スライド(先)カード設定
              v-flex(xs4)
                BaseFilterChip(chipName="適用" :active="searchCondItem.isSlideDestCard" @changeFilter="(value) => searchCondItem.isSlideDestCard = value")

      v-tab-item(value="tab2")
        v-card(flat)
          v-card-text.dispatch_filter_card
            DispatchClientFilter(ref="DispatchClientFilter" v-bind:prop-data="clientList" @click="(value) => searchCondItem.clientId = value" @clickBranch="(value) => searchCondItem.clientBranchId = value")
      v-tab-item(value="tab3")
        v-card(flat)
          v-card-text.dispatch_filter_card
            DispatchAreaFilter(ref="DispatchAreaFilter" v-bind:prop-data="areaList" @click="(value) => searchCondItem.vehicleGarageArea = value")
</template>

<script>
import BaseFilterChip from "@/components/common/BaseFilterChip";
import ClassifiedCardMarkIcon from "@/components/dispatch/ClassifiedCardMarkIcon";
import DispatchClientFilter from "@/components/dispatch/DispatchClientFilter";
import DispatchAreaFilter from "@/components/dispatch/DispatchAreaFilter";
import _ from "lodash";
import * as Enum from "@/assets/js/enum";
import { useCardMarkType } from "@/composables/dispatch/useCardMarkType";

export default {
  setup() {
    const { CARD_MARKS } = useCardMarkType();

    return {
      ...CARD_MARKS
    };
  },
  components: {
    BaseFilterChip,
    ClassifiedCardMarkIcon,
    DispatchClientFilter,
    DispatchAreaFilter
  },
  data() {
    return {
      model: "tab1",
      conditions: {
        displayAbsentDriver: false
      },
      searchCondItem: {},
      searchCondItemDef: {
        loadingDate: null,
        specifiedTime: false,
        vehicleType: [],
        vehicleCarryWeight: {
          w0_11: { value: Enum.CarryWeightType.CarryWeightType10.code, active: false },
          w11_13: { value: Enum.CarryWeightType.CarryWeightType20.code, active: false },
          w13_14: { value: Enum.CarryWeightType.CarryWeightType30.code, active: false },
          w14_o: { value: Enum.CarryWeightType.CarryWeightType40.code, active: false }
        },
        vehicleOption: [],
        drivableVehicleType: [],
        driverShift: {
          day: { value: Enum.ShiftType.Day.code, active: false },
          night: { value: Enum.ShiftType.Night.code, active: false },
          rest: { value: Enum.ShiftType.Rest.code, active: false }
        },
        isFavoriteOn: false,
        isFavoriteOff: false,
        operatingConditions: {
          isNotFirst: { value: Enum.operatingConditionList.isNotFirst.code, active: false },
          isNightLoading: { value: Enum.operatingConditionList.isNightLoading.code, active: false }
        },
        liftType: {
          reach: { value: Enum.LiftType.Reach.code, active: false },
          counter: { value: Enum.LiftType.Counter.code, active: false },
          both: { value: Enum.LiftType.Both.code, active: false }
        },
        contractType: {
          employee: { value: Enum.ContractType.Employee.code, active: false },
          exclusive: { value: Enum.ContractType.Exclusive.code, active: false },
          spot: { value: Enum.ContractType.Spot.code, active: false }
        },
        firstMailType: {
          unsent: { value: Enum.MailStatusType.Unsent.code, active: false },
          sent: { value: Enum.MailStatusType.Sent.code, active: false },
          read: { value: Enum.MailStatusType.Read.code, active: false },
          confirmed: { value: Enum.MailStatusType.Confirm.code, active: false }
        },
        allMailType: {
          unsent: { value: Enum.MailStatusType.Unsent.code, active: false },
          sent: { value: Enum.MailStatusType.Sent.code, active: false },
          read: { value: Enum.MailStatusType.Read.code, active: false },
          confirmed: { value: Enum.MailStatusType.Confirm.code, active: false }
        },

        firstLineType: {
          unsent: { value: Enum.MailStatusType.Unsent.code, active: false },
          sent: { value: Enum.MailStatusType.Sent.code, active: false },
          read: { value: Enum.MailStatusType.Read.code, active: false },
          confirmed: { value: Enum.MailStatusType.Confirm.code, active: false }
        },
        allLineType: {
          unsent: { value: Enum.MailStatusType.Unsent.code, active: false },
          sent: { value: Enum.MailStatusType.Sent.code, active: false },
          read: { value: Enum.MailStatusType.Read.code, active: false },
          confirmed: { value: Enum.MailStatusType.Confirm.code, active: false }
        },

        driverContactType: {
          line: { value: Enum.DriverContactType.Line.code, active: false },
          mail: { value: Enum.DriverContactType.Mail.code, active: false },
          none: { value: Enum.DriverContactType.None.code, active: false }
        },

        isEmptyCard: false,
        isSlideDestCard: false,
        isBjiImportBaseChanged: false,
        isOverWeight: false,
        isOverWeightBjiDiff: false,
        isVehicleInActive: false,
        isIncompleteLiftType: false,
        isIncompleteVehicleOption: false,
        deliveryCompanyName: "",
        primaryContractorName: "",
        driverName: "",
        vehicleNumber: "",
        shipmentNo: "",
        dispatchDetailIds: "",
        cardIds: "",
        loadingBaseName: "",
        unloadingBaseName: "",
        mark: {
          mark1: { value: Enum.CardMarkType.MarkOne.code, active: false },
          mark2: { value: Enum.CardMarkType.MarkTwo.code, active: false },
          mark3: { value: Enum.CardMarkType.MarkThree.code, active: false },
          mark4: { value: Enum.CardMarkType.MarkFour.code, active: false },
          mark5: { value: Enum.CardMarkType.MarkFive.code, active: false },
          mark6: { value: Enum.CardMarkType.MarkSix.code, active: false },
          mark7: { value: Enum.CardMarkType.MarkSeven.code, active: false },
          mark8: { value: Enum.CardMarkType.MarkEight.code, active: false },
          mark9: { value: Enum.CardMarkType.MarkNine.code, active: false },
          mark10: { value: Enum.CardMarkType.MarkTen.code, active: false },
          mark11: { value: Enum.CardMarkType.MarkEleven.code, active: false },
          mark12: { value: Enum.CardMarkType.MarkTwelve.code, active: false },
          mark13: { value: Enum.CardMarkType.MarkThirteen.code, active: false }
        },
        isComplete: null,
        onlyGps: false,
        clientId: [],
        clientBranchId: [],
        vehicleGarageArea: []
      }
    };
  },
  computed: {
    vehicleTypeList: {
      get() {
        let vehicleTypeList = this.$store.state.site.vehicleTypeIds;
        vehicleTypeList.map(value => {
          value.active = false;
        });
        return vehicleTypeList;
      }
    },
    drivableVehicleTypeList: {
      get() {
        let drivableVehicleTypeList = _.cloneDeep(this.$store.state.site.vehicleTypeIds);
        drivableVehicleTypeList.map(value => {
          value.active = false;
        });
        return drivableVehicleTypeList;
      }
    },
    vehicleOptionList: {
      get() {
        let vehicleOptionList = this.$store.state.site.vehicleOptionTypes;
        vehicleOptionList.map(value => {
          value.active = false;
        });
        return vehicleOptionList;
      }
    },
    vehicleType: {
      get() {
        let vehicleTypeList = [];
        this.searchCondItem.vehicleType.map(value => {
          if (value.active) vehicleTypeList.push(value.id);
        });
        return vehicleTypeList;
      }
    },
    vehicleCarryWeight: {
      get() {
        let vehicleCarryWeightList = [];
        if (_.get(this.searchCondItem.vehicleCarryWeight, "w0_11.active") === true)
          vehicleCarryWeightList.push(this.searchCondItem.vehicleCarryWeight.w0_11.value);
        if (_.get(this.searchCondItem.vehicleCarryWeight, "w11_13.active") === true)
          vehicleCarryWeightList.push(this.searchCondItem.vehicleCarryWeight.w11_13.value);
        if (_.get(this.searchCondItem.vehicleCarryWeight, "w13_14.active") === true)
          vehicleCarryWeightList.push(this.searchCondItem.vehicleCarryWeight.w13_14.value);
        if (_.get(this.searchCondItem.vehicleCarryWeight, "w14_o.active") === true)
          vehicleCarryWeightList.push(this.searchCondItem.vehicleCarryWeight.w14_o.value);
        return vehicleCarryWeightList;
      }
    },
    vehicleOption: {
      get() {
        let vehicleOptionList = [];
        this.searchCondItem.vehicleOption.map(value => {
          if (value.active) vehicleOptionList.push(value.code);
        });
        return vehicleOptionList;
      }
    },
    drivableVehicleType: {
      get() {
        let drivableVehicleTypeList = [];
        this.searchCondItem.drivableVehicleType.map(value => {
          if (value.active) drivableVehicleTypeList.push(value.id);
        });
        return drivableVehicleTypeList;
      }
    },
    driverShift: {
      get() {
        let driverShiftList = [];
        if (_.get(this.searchCondItem.driverShift, "day.active") === true)
          driverShiftList.push(this.searchCondItem.driverShift.day.value);
        if (_.get(this.searchCondItem.driverShift, "night.active") === true)
          driverShiftList.push(this.searchCondItem.driverShift.night.value);
        if (_.get(this.searchCondItem.driverShift, "rest.active") === true)
          driverShiftList.push(this.searchCondItem.driverShift.rest.value);
        return driverShiftList;
      }
    },
    operatingConditions: {
      get() {
        let operatingConditionList = [];
        if (_.get(this.searchCondItem.operatingConditions, "isNotFirst.active") === true)
          operatingConditionList.push(this.searchCondItem.operatingConditions.isNotFirst.value);
        if (_.get(this.searchCondItem.operatingConditions, "isNightLoading.active") === true)
          operatingConditionList.push(this.searchCondItem.operatingConditions.isNightLoading.value);
        return operatingConditionList;
      }
    },
    liftType: {
      get() {
        let liftTypeList = [];
        if (_.get(this.searchCondItem.liftType, "reach.active") === true)
          liftTypeList.push(this.searchCondItem.liftType.reach.value);
        if (_.get(this.searchCondItem.liftType, "counter.active") === true)
          liftTypeList.push(this.searchCondItem.liftType.counter.value);
        if (_.get(this.searchCondItem.liftType, "both.active") === true)
          liftTypeList.push(this.searchCondItem.liftType.both.value);
        return liftTypeList;
      }
    },
    contractType: {
      get() {
        let contractTypeList = [];
        if (_.get(this.searchCondItem.contractType, "employee.active") === true)
          contractTypeList.push(this.searchCondItem.contractType.employee.value);
        if (_.get(this.searchCondItem.contractType, "exclusive.active") === true)
          contractTypeList.push(this.searchCondItem.contractType.exclusive.value);
        if (_.get(this.searchCondItem.contractType, "spot.active") === true)
          contractTypeList.push(this.searchCondItem.contractType.spot.value);
        return contractTypeList;
      }
    },
    firstMailType: {
      get() {
        let firstMailType = [];
        if (_.get(this.searchCondItem.firstMailType, "unsent.active") === true)
          firstMailType.push(this.searchCondItem.firstMailType.unsent.value);
        if (_.get(this.searchCondItem.firstMailType, "sent.active") === true)
          firstMailType.push(this.searchCondItem.firstMailType.sent.value);
        if (_.get(this.searchCondItem.firstMailType, "read.active") === true)
          firstMailType.push(this.searchCondItem.firstMailType.read.value);
        if (_.get(this.searchCondItem.firstMailType, "confirmed.active") === true)
          firstMailType.push(this.searchCondItem.firstMailType.confirmed.value);
        return firstMailType;
      }
    },
    allMailType: {
      get() {
        let allMailTypeType = [];
        if (_.get(this.searchCondItem.allMailType, "unsent.active") === true)
          allMailTypeType.push(this.searchCondItem.allMailType.unsent.value);
        if (_.get(this.searchCondItem.allMailType, "sent.active") === true)
          allMailTypeType.push(this.searchCondItem.allMailType.sent.value);
        if (_.get(this.searchCondItem.allMailType, "read.active") === true)
          allMailTypeType.push(this.searchCondItem.allMailType.read.value);
        if (_.get(this.searchCondItem.allMailType, "confirmed.active") === true)
          allMailTypeType.push(this.searchCondItem.allMailType.confirmed.value);
        return allMailTypeType;
      }
    },
    firstLineType: {
      get() {
        let firstLineType = [];
        if (_.get(this.searchCondItem.firstLineType, "unsent.active") === true)
          firstLineType.push(this.searchCondItem.firstLineType.unsent.value);
        if (_.get(this.searchCondItem.firstLineType, "sent.active") === true)
          firstLineType.push(this.searchCondItem.firstMailType.sent.value);
        if (_.get(this.searchCondItem.firstLineType, "read.active") === true)
          firstLineType.push(this.searchCondItem.firstMailType.read.value);
        if (_.get(this.searchCondItem.firstLineType, "confirmed.active") === true)
          firstLineType.push(this.searchCondItem.firstLineType.confirmed.value);
        return firstLineType;
      }
    },
    allLineType: {
      get() {
        let allLineType = [];
        if (_.get(this.searchCondItem.allLineType, "unsent.active") === true)
          allLineType.push(this.searchCondItem.allLineType.unsent.value);
        if (_.get(this.searchCondItem.allLineType, "sent.active") === true)
          allLineType.push(this.searchCondItem.allLineType.sent.value);
        if (_.get(this.searchCondItem.allLineType, "read.active") === true)
          allLineType.push(this.searchCondItem.allLineType.read.value);
        if (_.get(this.searchCondItem.allLineType, "confirmed.active") === true)
          allLineType.push(this.searchCondItem.allLineType.confirmed.value);
        return allLineType;
      }
    },
    driverContactType: {
      get() {
        let allLineType = [];
        if (_.get(this.searchCondItem.driverContactType, "line.active") === true)
          allLineType.push(this.searchCondItem.driverContactType.line.value);
        if (_.get(this.searchCondItem.driverContactType, "mail.active") === true)
          allLineType.push(this.searchCondItem.driverContactType.mail.value);
        if (_.get(this.searchCondItem.driverContactType, "none.active") === true)
          allLineType.push(this.searchCondItem.driverContactType.none.value);
        return allLineType;
      }
    },
    mark: {
      get() {
        let markList = [];
        if (_.get(this.searchCondItem.mark, "mark1.active") === true)
          markList.push(this.searchCondItem.mark.mark1.value);
        if (_.get(this.searchCondItem.mark, "mark2.active") === true)
          markList.push(this.searchCondItem.mark.mark2.value);
        if (_.get(this.searchCondItem.mark, "mark3.active") === true)
          markList.push(this.searchCondItem.mark.mark3.value);
        if (_.get(this.searchCondItem.mark, "mark4.active") === true)
          markList.push(this.searchCondItem.mark.mark4.value);
        if (_.get(this.searchCondItem.mark, "mark5.active") === true)
          markList.push(this.searchCondItem.mark.mark5.value);
        if (_.get(this.searchCondItem.mark, "mark6.active") === true)
          markList.push(this.searchCondItem.mark.mark6.value);
        if (_.get(this.searchCondItem.mark, "mark7.active") === true)
          markList.push(this.searchCondItem.mark.mark7.value);
        if (_.get(this.searchCondItem.mark, "mark8.active") === true)
          markList.push(this.searchCondItem.mark.mark8.value);
        if (_.get(this.searchCondItem.mark, "mark9.active") === true)
          markList.push(this.searchCondItem.mark.mark9.value);
        if (_.get(this.searchCondItem.mark, "mark10.active") === true)
          markList.push(this.searchCondItem.mark.mark10.value);
        if (_.get(this.searchCondItem.mark, "mark11.active") === true)
          markList.push(this.searchCondItem.mark.mark11.value);
        if (_.get(this.searchCondItem.mark, "mark12.active") === true)
          markList.push(this.searchCondItem.mark.mark12.value);
        if (_.get(this.searchCondItem.mark, "mark13.active") === true)
          markList.push(this.searchCondItem.mark.mark13.value);
        return markList;
      }
    }
  },
  methods: {
    clearDriverContactType() {
      this.searchCondItem.driverContactType.line.active = false;
      this.searchCondItem.driverContactType.mail.active = false;
      this.searchCondItem.driverContactType.none.active = false;
    },
    setDriverContactTypeLine(flg) {
      this.clearDriverContactType();
      this.searchCondItem.driverContactType.line.active = flg;
    },
    setDriverContactTypeMail(flg) {
      this.clearDriverContactType();
      this.searchCondItem.driverContactType.mail.active = flg;
    },
    setDriverContactTypeNone(flg) {
      this.clearDriverContactType();
      this.searchCondItem.driverContactType.none.active = flg;
    },
    addSearchCond(data) {
      data.specifiedTime = this.searchCondItem.specifiedTime;
      data.vehicleType = this.vehicleType;
      data.vehicleCarryWeight = this.vehicleCarryWeight;
      data.vehicleOption = this.vehicleOption;
      data.drivableVehicleType = this.drivableVehicleType;
      data.driverShift = this.driverShift;
      data.isFavorite = this.searchCondItem.isFavorite;
      data.isFavoriteOn = this.searchCondItem.isFavoriteOn;
      data.isFavoriteOff = this.searchCondItem.isFavoriteOff;
      data.loadingBaseName = this.searchCondItem.loadingBaseName;
      data.unloadingBaseName = this.searchCondItem.unloadingBaseName;
      data.operatingConditions = this.operatingConditions;
      data.liftType = this.liftType;
      data.contractType = this.contractType;
      data.firstMailType = this.firstMailType;
      data.allMailType = this.allMailType;
      data.firstLineType = this.firstLineType;
      data.allLineType = this.allLineType;
      data.driverContactType = this.driverContactType;
      data.isEmptyCard = this.searchCondItem.isEmptyCard;
      data.isSlideDestCard = this.searchCondItem.isSlideDestCard;
      data.isBjiImportBaseChanged = this.searchCondItem.isBjiImportBaseChanged;
      data.isOverWeight = this.searchCondItem.isOverWeight;
      data.isOverWeightBjiDiff = this.searchCondItem.isOverWeightBjiDiff;
      data.isVehicleInActive = this.searchCondItem.isVehicleInActive;
      data.isIncompleteLiftType = this.searchCondItem.isIncompleteLiftType;
      data.isIncompleteVehicleOption = this.searchCondItem.isIncompleteVehicleOption;
      data.driverName = this.searchCondItem.driverName;
      data.deliveryCompanyName = this.searchCondItem.deliveryCompanyName;
      data.primaryContractorName = this.searchCondItem.primaryContractorName;
      data.vehicleNumber = this.searchCondItem.vehicleNumber;
      data.shipmentNo = this.searchCondItem.shipmentNo;
      data.dispatchDetailIds = this.searchCondItem.dispatchDetailIds;
      data.cardIds = this.searchCondItem.cardIds;
      data.mark = this.mark;
      data.isComplete = this.searchCondItem.isComplete;
      data.onlyGps = this.searchCondItem.onlyGps;
      data.clientId = this.searchCondItem.clientId;
      data.clientBranchId = this.searchCondItem.clientBranchId;
      data.vehicleGarageArea = this.searchCondItem.vehicleGarageArea;
      return data;
    },
    clearSearchCond(data) {
      this.searchCondItem = _.cloneDeep(this.searchCondItemDef);
      this.$refs.DispatchClientFilter.clearSelected();
      this.$refs.DispatchAreaFilter.clearSelected();
      this.setDefaultSelect();
      return this.addSearchCond(data);
    },
    setDefaultSelect() {
      if (!this.isDynamic) {
        this.searchCondItem.driverShift.day.active = true;
        this.searchCondItem.driverShift.night.active = true;
      }
    },
    trigger() {
      this.$emit("onChangeScheduleConditions", this.searchCondItem);
    },
    loadingDown() {
      this.loading = false;
    },
    setApiData() {
      this.searchCondItemDef.vehicleType = this.vehicleTypeList;
      this.searchCondItemDef.drivableVehicleType = this.drivableVehicleTypeList;
      this.searchCondItemDef.vehicleOption = this.vehicleOptionList;
    }
  },
  watch: {
    searchCondItem: {
      handler: function (newValue) {
        this.debouncedTrigger(newValue);
      },
      deep: true
    }
  },
  created() {
    this.debouncedTrigger = _.debounce(this.trigger, 500);
    this.setApiData();
    this.searchCondItem = _.cloneDeep(this.searchCondItemDef);
    this.setDefaultSelect();
  },
  mounted() {
    window.addEventListener(
      window.Common.Config.observer.onPagingListTableAjaxCompleted,
      this.loadingDown,
      false
    );
  },
  destroyed() {
    window.removeEventListener(
      window.Common.Config.observer.onPagingListTableAjaxCompleted,
      this.loadingDown
    );
  },
  props: {
    clientList: {
      type: Array,
      required: true
    },
    areaList: {
      type: Array,
      required: true
    },
    isDynamic: {
      type: Boolean,
      required: false,
      default: () => false
    }
  }
};
</script>

<style lang="stylus" scoped>
.dispatch_filter_card {
  max-height: 800px;
  min-width: 1000px;
  overflow-y: auto;
  padding-top: 0;
}

.filter-container {
  padding: 8px !important;
}

.filter-card {
  margin: 4px;
  border: 1px solid #e0e0e0 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;

  .v-card__title {
    background-color: #f5f5f5;
    font-weight: bold;
    min-height: 40px;
    padding: 8px 12px !important;

    .subheading {
      font-size: 14px;
      font-weight: 600;
    }
  }

  .v-card__text {
    max-height: 600px;
    overflow-y: auto;
  }
}

.item-label {
  font-size: 12px;
  font-weight: 500;
  color: #616161;
  margin-bottom: 4px;
  padding-top: 8px;
}

.item-content {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 4px;
}

.mark-chips {
  max-height: 80px;
  overflow-y: auto;
}

.filter-item-compact {
  margin-bottom: 4px;

  .item-label {
    font-size: 11px;
    font-weight: 500;
    color: #616161;
    margin-bottom: 2px;
    padding-top: 4px;
  }

  .item-content {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
  }
}

.v-text-field {
  font-size: 13px;
}

.v-textarea {
  font-size: 13px;
}
</style>
